import { defineStore } from 'pinia';

export const agenciaStoreModule = defineStore('agenciaStore', {
  state: () => ({
    nombre: null,
    email: null,
    currencySymbol: null,
    locale: 'es',
    telefono: null,
    whatsapp: null,
    buscadorForfaitEnabled: true,
    buscadorEnabled: null,
    recursos: {
      avisosLegales: null,
      imagenFondo: null,
      metaTitulo: null,
      metaDescripcion: null,
      css: null,
      permisos: null,
      favicon: null,
    },
    integraciones: {
      whatsapp: null,
      meta: null,
      googleAnalytics: null,
      googleOauth: null,
    },
    termsConditions: null,
  }),
  getters: {
    getCurrency(state) {
      return state.currencySymbol;
    },
    getCurrencyName(state) {
      return state.currencyName;
    },
    getTelefono(state) {
      return state.telefono;
    },
    getEmail(state) {
      return state.email;
    },
    getLocale(state) {
      return state.locale;
    },
    getWhatsapp(state) {
      return state.integraciones.whatsapp;
    },
    getMeta(state) {
      return state.integraciones.meta;
    },
    getGoogleAnalitycs(state) {
      return state.integraciones.googleAnalytics;
    },
    getGoogleOauth(state) {
      return state.integraciones.googleOauth;
    },
    getImagenFondo(state) {
      return state.recursos.imagenFondo;
    },
    getMetaTitulo(state) {
      return state.recursos.metaTitulo;
    },
    getMetaDescripcion(state) {
      return state.recursos.metaDescripcion;
    },
    getCss(state) {
      return state.recursos.css;
    },
    getPermisos(state) {
      return state.recursos.permisos;
    },
    getFavicon(state) {
      return state.recursos.favicon;
    },
    getTermsConditions(state) {
      return state.termsConditions;
    },
  },
  actions: {
    setData(hAgenciaDto) {
      this.nombre = hAgenciaDto.nombre;
      this.email = hAgenciaDto.email;
      this.currencySymbol = hAgenciaDto.currencySymbol;
      this.currencyName = hAgenciaDto.currencyName;
      this.locale = hAgenciaDto.locale;
      this.telefono = hAgenciaDto.telefono;
      this.buscadorForfaitEnabled = hAgenciaDto.buscadorForfaitEnabled;
      this.buscadorEnabled = hAgenciaDto.buscadorEnabled;
      this.recursos.imagenFondo = hAgenciaDto.recursos.img_mis_reservas_fondo;
      this.recursos.metaTitulo = hAgenciaDto.recursos.meta_titulo;
      this.recursos.metaDescripcion = hAgenciaDto.recursos.meta_descripcion;
      this.recursos.css = hAgenciaDto.recursos.css;
      this.recursos.permisos = hAgenciaDto.recursos.permisos;
      this.recursos.favicon = hAgenciaDto.recursos.favicon;
      this.integraciones.whatsapp = hAgenciaDto.integraciones.whatsapp;
      this.integraciones.meta = hAgenciaDto.integraciones.meta;
      this.integraciones.googleAnalytics = hAgenciaDto.integraciones.googleAnalytics;
      this.integraciones.googleOauth = hAgenciaDto.integraciones.googleOauth;
      this.termsConditions = hAgenciaDto.termsConditions;
    },
  },
});
